function HasClass( el, cls )
{
    var current = el.getAttribute( "class" );
    return ( ( current != undefined ) && ( current.indexOf( cls ) != -1 ) );
}

function AddClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( ( current == undefined ) || ( current.indexOf( cls ) == -1 ) )
        {
            current += " " + cls;
            el.setAttribute( "class", current );
        }
    }
}
function RemoveClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( current )
        {
            current = current.replace( cls, ' ' );
            el.setAttribute( "class", current );
        }
    }
}
function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function getChosenVariant( element )
{
    var options = element.querySelectorAll( "option" );

    for( var i = 0; i < options.length; i++ )
    {
        var option      = options[ i ];
        var selected    = element.selectedIndex;

        if( i == selected )
        {
            element.dataset.option  = option.value;
            setupEdgeTPReviews( option );
        }
    }
}

function setupEdgeTPReviews( selectedOption )
{
    var parent      = SearchParentsFor( selectedOption, "collection_product_container" );
    var tpReviews   = parent.querySelectorAll( ".edge-tp" );
    var select      = parent.querySelector( "select[ name='id' ]" );
    var options     = select.querySelectorAll( "option" );
    var variantId;

    for( var i = 0; i < options.length; i++ )
    {
        var option = options[ i ];
        if( option.dataset.option == selectedOption.value  )
        {
            variantId = option.value;
        }
    }

    for( var i = 0; i < tpReviews.length; i++ )
    {
        var review  = tpReviews[ i ];
        review.classList.add( "hidden" );
        console.log( review.dataset.variantID );
        if( variantId == review.dataset.variantId )
        {
            review.classList.remove( "hidden" );
        }
    }

}

function updateChosenVariant( element )
{
    stopPropagation( );
    var selectContainers        = document.querySelectorAll( ".cart--item" );
    var productInfoContainer    = SearchParentsFor( element, "collection-product-info-container" );
    var parent                  = SearchParentsFor( element, "collection_product_container" );
    var selects                 = productInfoContainer.querySelectorAll( "select" );

    var product = getProductData( parent, selects );
    if( product )
    {
        UpdateProduct( product.value, element )
    }
}

function UpdateProduct( value, element )
{

    var newVariant      = value;
    var qty             = 1;

    var xhr     = new XMLHttpRequest( );
    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( xhr.status == 200 )
            {
                // AddNewVariant( qty, newVariant );
                console.log( "added" );
                handleProductAdded( element );
            }
            else
            {
                console.log( "adding variant failed" + xhr.responseText );
                handleBadRequest( JSON.parse( xhr.response ), element );
            }
        }
    };

    xhr.open( "POST", "/cart/add.js", true );
    xhr.setRequestHeader( "Content-Type", "application/json" );
    xhr.send( JSON.stringify( { "quantity" : qty, "id" : newVariant } ) );

}

function handleBadRequest( response, element )
{
    var parent      = SearchParentsFor( element, "collection_product_container" ); 
    var container   = parent.querySelector( ".collection_select_container" );
    if( !container.querySelector( ".collection-error" ) )
    {
        var p           = document.createElement( "p" );
        var option      = parent.querySelector( ".visible-option" ).dataset.option;
        p.innerHTML     = "Please select a " + option;
        p.setAttribute( "style", "color: #e600ac; font-size: 17px" );
        p.classList.add( "collection-error" );
        container.appendChild( p );
    }
}

function handleProductAdded( element )
{
    var parent      = SearchParentsFor( element, "collection_product_container" ); 
    var container   = parent.querySelector( ".collection_select_container" );
    var error       = container.querySelector( ".collection-error" )
    if( error )
    {
        error.parentNode.removeChild( error );
    }

    if( !parent.querySelector( ".collection-added" ) )
    {
        var p           = document.createElement( "p" );
        p.innerHTML     = "Added";
        p.setAttribute( "style", "color: #e600ac; font-size: 17px" );
        p.classList.add( "collection-added" );
        container.appendChild( p );
    }    
}

function getProductData( parent, selects )
{
    var option1;
    var option2;
    var option3; 
    var product = {};

    if( selects && selects.length )
    {
        for( var i = 0; i < selects.length; i++ )
        {
            var select = selects[ i ];
            var option = select.dataset.option;
            if( option )
            {
                console.log( option );
                if( i == 0 )
                {
                    option1 = option;
                }
                if( i == 1 )
                {
                    option2 = option;
                }
                if( i == 2 )
                {
                    option3 = option;
                }
    
                var selectedVariant;
                if( option1 && option2 && option3 )
                {
                    var selectedVariant         = option1 + " / " + option2 + " / " + option3;
                }
                else if( (option1 && option2) && (option3 == undefined) )
                {
                    var selectedVariant         = option1 + " / " + option2;
                }
                else if( (option1) && ( option2 == undefined && option3 == undefined ) )
                {
                    var selectedVariant         = option1;
                }
                console.log( selectedVariant );
                var productVariant          = parent.querySelector( ".collection-product-select-hidden" );
                var productVariantOptions   = productVariant.querySelectorAll( "option" );
                for( var k = 0; k < productVariantOptions.length; k++ )
                {
                    var productVariantOption = productVariantOptions[ k ];
                    if( selectedVariant == productVariantOption.innerHTML )
                    {
                        product.value   = productVariantOption.value
                        product.url     = productVariantOption.dataset.url;
                    }
                }
            }
            else
            {
                product.url     = parent.querySelector( ".variant-selects-and-ids" ).dataset.producturl;
            }
        }
    }
    else
    {
        //default variant
        product.value = parent.querySelector( ".variant-selects-and-ids option" ).value;
        product.url = parent.querySelector( ".variant-selects-and-ids option" ).dataset.url;
    }
    return product;
}

function ShowProduct( element )
{
    var productInfoContainer;
    var parent;

    if( element.classList.contains( "collection_product_container" ) )
    {
        productInfoContainer    = element.querySelector( ".collection-product-info-container" );
        parent                  = element;
    }
    else
    {
        productInfoContainer    = SearchParentsFor( element, "collection-product-info-container" );
        var parent                  = SearchParentsFor( element, "collection_product_container" );
    }
    var selects                 = productInfoContainer.querySelectorAll( "select" );

    var product = getProductData( parent, selects );
    console.log( product );
    if( product )
    {
        GoToProduct( product.url );
    }
}

function GoToProduct( url )
{
    window.location.href = url;
}

function stopPropagation( )
{
    window.event.preventDefault();
    window.event.stopPropagation();
}

function InitialiseCollectionPage()
{
    showFilter();
    SetupProductSelect();
    // ShowCollectionDescription();
}

// function ShowCollectionDescription()
// {
//     var container = document.querySelector( ".collection_metafiield_container" );
//     if( container.classList.contains( "on-desktop-only" ) )
//     {
//         container.querySelector( ".collection_metafield_title_container" ).click();
//     }
// }

function showFilter()
{
    var collectionHandle    = document.querySelector( ".collection_metafield_title_container" ).dataset.handle;
    var pathname            = window.location.pathname;
    var urlFilter           = pathname.replace( "/collections/" + collectionHandle + "/", '' );
    var filter              = urlFilter.split( '-' )[ 0 ];

    var filterContainer     = document.querySelector( ".collection_left_filter_container" );
    var filterTitles        = filterContainer.querySelectorAll( ".collection_metafield_title_container p" );
    var selectedFilter;
    var filteredCollection  = false;

    for( var i = 0; i < filterTitles.length; i++ )
    {
        var title = filterTitles[ i ];
        console.log( 'here' );
        if( title.innerHTML == ( filter.charAt( 0 ).toUpperCase() + filter.slice( 1 ) ) )
        {
            selectedFilter = title.parentNode;
            filteredCollection = true;
            break;
        }
    }

    if( filteredCollection )
    {
        var parent      = SearchParentsFor( selectedFilter, "filter-container" );
        var filters     = parent.querySelectorAll( ".collection_child_link-text-container" );
        for( var i = 0; i < filters.length; i++ )
        {
            var filter      = filters[ i ];
            var container   = SearchParentsFor( filter, "collection_child_link-container" );
            if( filter.dataset.filter == urlFilter.split( '-' )[ 1 ] )
            {
                var imageContainer = container.querySelector(".collection_child_link-image-container" );
                imageContainer.querySelector( "img" ).src = imageContainer.dataset.activeimage;
            }
            else if( filter.dataset.filter == urlFilter.split( '-' )[ 1 ] + "-" + urlFilter.split( '-' )[ 2 ] )
            {
                var imageContainer = container.querySelector(".collection_child_link-image-container" );
                imageContainer.querySelector( "img" ).src = imageContainer.dataset.activeimage;                
            }
        }
    }

    if( selectedFilter == undefined )
    {
        if( pathname.includes( collectionHandle ) )
        {
            selectedFilter = document.querySelector( ".range-filter" );
        }
    }

    if( selectedFilter )
    {
        RevealMetadataCollection( selectedFilter );
    }

}

function SetupProductSelect()
{
    var products    = document.querySelectorAll( ".collection_product_container" );
    var windowWidth = window.innerWidth;
    console.log( windowWidth );
    for( var i = 0; i < products.length; i++ )
    {
        var product         = products[ i ];
        var select          = product.querySelector( "select" );
        var visibleOption   = select.querySelector( ".visible-option" );

        if( windowWidth > 750 )
        {
            visibleOption.innerHTML = "Change - " + visibleOption.dataset.option;
        }
        else
        {
            visibleOption.innerHTML = visibleOption.dataset.option;
        }
    }
}

function filterGoToCollection( element )
{
    var parent  = SearchParentsFor( element, "collection_metafield_content_inner" );
    var images  = parent.querySelectorAll( ".filter-image" );

    for( var i = 0; i < images.length; i++ )
    {
        var image = images[ i ];

        if( image.src.includes( element.dataset.activeimage ) )
        {
            image.src = element.dataset.inactiveimage;
        }
    }

    element.querySelector( "img" ).src = element.dataset.activeimage;

    window.location.href = element.dataset.url;
}

function screenSizeChange( mediaQuery ) 
{
    if ( mediaQuery.matches ) 
    { 
        // If media query matches
        SetupProductSelect();
    } 
    else 
    {
        SetupProductSelect();
    }
}
  
var mediaQuery = window.matchMedia("(max-width: 750px)")
screenSizeChange( mediaQuery ) // Call listener function at run time
mediaQuery.addListener( screenSizeChange ) // Attach listener function on state changes

window.addEventListener( "DOMContentLoaded", function()
{
    InitialiseCollectionPage();
} );